let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7tqqd")).then(() => parcelRequire('3oVAl'));